export default {
  code: 'UG',
  countryName: 'UGA',
  // googleSiteVerificationCode: '1uUi471agIlOfQQ3ns5BSv78-YAYOVbuPdRyGUsfq2I',
  googleSiteVerificationCode: [],
  countryDomain: 'https://www.carrefour.ug',
  helplineNumber: '',
  latitude: 25.217392942107853,
  longitude: 55.36187758635983,
  defaultAreaCode: '',
  features: {
    languageChange: false,
    now: false,
    share: false,
    isLocationCXEnable: false,
    isNewAddress: false,
    cashback: false,
    linkMyClubCard: false,
    oneTrustScript: '59e1df96-0476-40c0-b2c0-5c9de27a46a5'
  }
}
